import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { BaseMessageSignerWalletAdapter, pollUntilReady, WalletConnectionError, WalletDisconnectedError, WalletDisconnectionError, WalletError, WalletNotConnectedError, WalletNotFoundError, WalletNotInstalledError, WalletPublicKeyError, WalletSignTransactionError, WalletWindowClosedError } from '@solana/wallet-adapter-base';
import { PublicKey } from '@solana/web3.js';
export var PhantomWalletAdapter = /*#__PURE__*/function (_BaseMessageSignerWal) {
  _inherits(PhantomWalletAdapter, _BaseMessageSignerWal);

  var _super = _createSuper(PhantomWalletAdapter);

  function PhantomWalletAdapter() {
    var _this;

    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, PhantomWalletAdapter);

    _this = _super.call(this);

    _this._disconnected = function () {
      var wallet = _this._wallet;

      if (wallet) {
        wallet.off('disconnect', _this._disconnected);
        _this._wallet = null;
        _this._publicKey = null;

        _this.emit('error', new WalletDisconnectedError());

        _this.emit('disconnect');
      }
    };

    _this._connecting = false;
    _this._wallet = null;
    _this._publicKey = null;
    if (!_this.ready) pollUntilReady(_assertThisInitialized(_this), config.pollInterval || 1000, config.pollCount || 3);
    return _this;
  }

  _createClass(PhantomWalletAdapter, [{
    key: "publicKey",
    get: function get() {
      return this._publicKey;
    }
  }, {
    key: "ready",
    get: function get() {
      var _a;

      return typeof window !== 'undefined' && !!((_a = window.solana) === null || _a === void 0 ? void 0 : _a.isPhantom);
    }
  }, {
    key: "connecting",
    get: function get() {
      return this._connecting;
    }
  }, {
    key: "connected",
    get: function get() {
      var _a;

      return !!((_a = this._wallet) === null || _a === void 0 ? void 0 : _a.isConnected);
    }
  }, {
    key: "connect",
    value: function connect() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var wallet, handleDisconnect, publicKey;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                if (!(this.connected || this.connecting)) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return");

              case 3:
                this._connecting = true;
                wallet = typeof window !== 'undefined' && window.solana;

                if (wallet) {
                  _context.next = 7;
                  break;
                }

                throw new WalletNotFoundError();

              case 7:
                if (wallet.isPhantom) {
                  _context.next = 9;
                  break;
                }

                throw new WalletNotInstalledError();

              case 9:
                if (wallet.isConnected) {
                  _context.next = 24;
                  break;
                }

                // HACK: Phantom doesn't reject or emit an event if the popup is closed
                handleDisconnect = wallet._handleDisconnect;
                _context.prev = 11;
                _context.next = 14;
                return new Promise(function (resolve, reject) {
                  var connect = function connect() {
                    wallet.off('connect', connect);
                    resolve();
                  };

                  wallet._handleDisconnect = function () {
                    wallet.off('connect', connect);
                    reject(new WalletWindowClosedError());

                    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                      args[_key] = arguments[_key];
                    }

                    return handleDisconnect.apply(wallet, args);
                  };

                  wallet.on('connect', connect);
                  wallet.connect().catch(function (reason) {
                    wallet.off('connect', connect);
                    reject(reason);
                  });
                });

              case 14:
                _context.next = 21;
                break;

              case 16:
                _context.prev = 16;
                _context.t0 = _context["catch"](11);

                if (!(_context.t0 instanceof WalletError)) {
                  _context.next = 20;
                  break;
                }

                throw _context.t0;

              case 20:
                throw new WalletConnectionError(_context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.message, _context.t0);

              case 21:
                _context.prev = 21;
                wallet._handleDisconnect = handleDisconnect;
                return _context.finish(21);

              case 24:
                if (wallet.publicKey) {
                  _context.next = 26;
                  break;
                }

                throw new WalletConnectionError();

              case 26:
                _context.prev = 26;
                publicKey = new PublicKey(wallet.publicKey.toBytes());
                _context.next = 33;
                break;

              case 30:
                _context.prev = 30;
                _context.t1 = _context["catch"](26);
                throw new WalletPublicKeyError(_context.t1 === null || _context.t1 === void 0 ? void 0 : _context.t1.message, _context.t1);

              case 33:
                wallet.on('disconnect', this._disconnected);
                this._wallet = wallet;
                this._publicKey = publicKey;
                this.emit('connect');
                _context.next = 43;
                break;

              case 39:
                _context.prev = 39;
                _context.t2 = _context["catch"](0);
                this.emit('error', _context.t2);
                throw _context.t2;

              case 43:
                _context.prev = 43;
                this._connecting = false;
                return _context.finish(43);

              case 46:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 39, 43, 46], [11, 16, 21, 24], [26, 30]]);
      }));
    }
  }, {
    key: "disconnect",
    value: function disconnect() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var wallet;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                wallet = this._wallet;

                if (!wallet) {
                  _context2.next = 13;
                  break;
                }

                wallet.off('disconnect', this._disconnected);
                this._wallet = null;
                this._publicKey = null;
                _context2.prev = 5;
                _context2.next = 8;
                return wallet.disconnect();

              case 8:
                _context2.next = 13;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](5);
                this.emit('error', new WalletDisconnectionError(_context2.t0 === null || _context2.t0 === void 0 ? void 0 : _context2.t0.message, _context2.t0));

              case 13:
                this.emit('disconnect');

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[5, 10]]);
      }));
    }
  }, {
    key: "signTransaction",
    value: function signTransaction(transaction) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var wallet;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                wallet = this._wallet;

                if (wallet) {
                  _context3.next = 4;
                  break;
                }

                throw new WalletNotConnectedError();

              case 4:
                _context3.prev = 4;
                _context3.next = 7;
                return wallet.signTransaction(transaction);

              case 7:
                _context3.t0 = _context3.sent;

                if (_context3.t0) {
                  _context3.next = 10;
                  break;
                }

                _context3.t0 = transaction;

              case 10:
                return _context3.abrupt("return", _context3.t0);

              case 13:
                _context3.prev = 13;
                _context3.t1 = _context3["catch"](4);
                throw new WalletSignTransactionError(_context3.t1 === null || _context3.t1 === void 0 ? void 0 : _context3.t1.message, _context3.t1);

              case 16:
                _context3.next = 22;
                break;

              case 18:
                _context3.prev = 18;
                _context3.t2 = _context3["catch"](0);
                this.emit('error', _context3.t2);
                throw _context3.t2;

              case 22:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 18], [4, 13]]);
      }));
    }
  }, {
    key: "signAllTransactions",
    value: function signAllTransactions(transactions) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var wallet;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                wallet = this._wallet;

                if (wallet) {
                  _context4.next = 4;
                  break;
                }

                throw new WalletNotConnectedError();

              case 4:
                _context4.prev = 4;
                _context4.next = 7;
                return wallet.signAllTransactions(transactions);

              case 7:
                _context4.t0 = _context4.sent;

                if (_context4.t0) {
                  _context4.next = 10;
                  break;
                }

                _context4.t0 = transactions;

              case 10:
                return _context4.abrupt("return", _context4.t0);

              case 13:
                _context4.prev = 13;
                _context4.t1 = _context4["catch"](4);
                throw new WalletSignTransactionError(_context4.t1 === null || _context4.t1 === void 0 ? void 0 : _context4.t1.message, _context4.t1);

              case 16:
                _context4.next = 22;
                break;

              case 18:
                _context4.prev = 18;
                _context4.t2 = _context4["catch"](0);
                this.emit('error', _context4.t2);
                throw _context4.t2;

              case 22:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 18], [4, 13]]);
      }));
    }
  }, {
    key: "signMessage",
    value: function signMessage(message) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var wallet, _yield$wallet$signMes, signature;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                wallet = this._wallet;

                if (wallet) {
                  _context5.next = 4;
                  break;
                }

                throw new WalletNotConnectedError();

              case 4:
                _context5.prev = 4;
                _context5.next = 7;
                return wallet.signMessage(message);

              case 7:
                _yield$wallet$signMes = _context5.sent;
                signature = _yield$wallet$signMes.signature;
                return _context5.abrupt("return", Uint8Array.from(signature));

              case 12:
                _context5.prev = 12;
                _context5.t0 = _context5["catch"](4);
                throw new WalletSignTransactionError(_context5.t0 === null || _context5.t0 === void 0 ? void 0 : _context5.t0.message, _context5.t0);

              case 15:
                _context5.next = 21;
                break;

              case 17:
                _context5.prev = 17;
                _context5.t1 = _context5["catch"](0);
                this.emit('error', _context5.t1);
                throw _context5.t1;

              case 21:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 17], [4, 12]]);
      }));
    }
  }]);

  return PhantomWalletAdapter;
}(BaseMessageSignerWalletAdapter);